// 时间处理
export const setMoment = (timestamp, noTime, reversal) => {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1 < 10 ? "0" : "") + (date.getMonth() + 1);
  const day = (date.getDate() < 10 ? "0" : "") + date.getDate();
  const hours = (date.getHours() < 10 ? "0" : "") + date.getHours();
  const minutes = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
  const seconds = (date.getSeconds() < 10 ? "0" : "") + date.getSeconds();
  let convertedTime;
  if (reversal && noTime) {
    convertedTime = `${day} / ${month} / ${year}`;
  } else if (noTime) {
    convertedTime = `${year}/${month}/${day}`;
  } else {
    convertedTime = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
  }
  return convertedTime;
};

// 从后向前每隔三位添加逗号
export const add_comma_toThousands = (num) => {
  var newNum = (num || 0).toString();
  var result = "";
  while (newNum.length > 3) {
    result = "," + newNum.slice(-3) + result;
    newNum = newNum.slice(0, newNum.length - 3);
  }
  if (newNum) {
    result = newNum + result;
  }
  return result;
};

export const convertDateToTimestamp = (dateString) => {
  var parts = dateString.split("/");
  // JavaScript中的Date对象月份是从0开始的，所以需要减1
  var year = parseInt(parts[2], 10); // 年份
  var month = parseInt(parts[0], 10) - 1; // 月份
  var day = parseInt(parts[1], 10); // 日期

  // 创建一个Date对象
  var dateObject = new Date(year, month, day);

  // 获取时间戳（单位：毫秒）
  var timestamp = dateObject.getTime();

  return timestamp;
};

// 邮箱验证
export const validateEmail = (email) => {
  // var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  var emailRegex = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  return emailRegex.test(email);
};

export const compressAndUpload = (baseUrl, file) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = baseUrl;
    img.onload = function() {
      const canvas = document.getElementById("canvas");
      const ctx = canvas.getContext("2d");
      const maxWidth = 800; // 设置最大宽度为800像素
      let width = img.width;
      let height = img.height;

      // 判断是否需要缩放
      if (width > maxWidth) {
        height *= maxWidth / width;
        width = maxWidth;
      }
      // 设置 canvas 的宽高
      canvas.width = width;
      canvas.height = height;

      // 将图片绘制到 canvas 上
      ctx.drawImage(img, 0, 0, width, height);
      // 获取压缩后的图片数据
      const compressedData = canvas.toDataURL("image/jpeg", 0.8); // 可调整质量参数
      // 创建一个新的压缩后的 File 对象
      const compressedFile = dataURItoBlob(compressedData, file.type);
      compressedFile.lastModifiedDate = file.lastModifiedDate;
      compressedFile.name = file.name;
      let newFile = new File([compressedFile], file.name, {
        type: compressedFile.type,
      });
      //   const formData = new FormData();
      //   formData.append("image", compressedFile);
      //   let newFile = formData.get("image");
      // 上传压缩后的图片文件
      resolve(newFile);
    };
  });
};

function dataURItoBlob(dataURI, mimeType) {
  const binary = atob(dataURI.split(",")[1]);
  const array = [];
  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }
  return new Blob([new Uint8Array(array)], { type: mimeType });
}

export const getBase64Image = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener("load", function(event) {
      // 事件的result属性包含了文件的Base64编码
      const base64String = event.target.result;
      // 你可以在这里使用base64String，例如发送到服务器或在页面上显示
      resolve(base64String);
    });
    reader.readAsDataURL(file);
  });
};

// function uploadImage(compressedFile) {
//   const formData = new FormData();
//   formData.append("image", compressedFile);
//   // fetch('/upload', {
//   //     method: 'POST',
//   //     body: formData
//   // })
//   // .then(response => {
//   //     if (response.ok) {
//   //         console.log('图片上传成功');
//   //     } else {
//   //         console.error('图片上传失败');
//   //     }
//   // })
//   // .catch(error => {
//   //     console.error('发生错误:', error);
//   // });
// }
